<template>
    <div role="tablist" class="sow-accordion">
        <div class="sow-accordion-panel" v-for="description in smeDescriptions" :key="description.key">
            <div class="p-1 sow-accordion-panel-header" v-b-toggle="description.key" role="tab">
                <div class="sow-accordion-title">
                    {{description.title}}
                    <div class="sow-accordion-open-close-button">
                        <div class="sow-accordion-button sow-accordion-button--open">
                            <span class="sow-accordion-button__arrow sow-accordion-button__arrow--open" data-sow-icon=""></span>					</div>
                        <div class="sow-accordion-button sow-accordion-button--close">
                            <span class="sow-accordion-button__arrow sow-accordion-button__arrow--close" data-sow-icon=""></span>					</div>
                    </div>
                </div>

            </div>
            <BCollapse :id="description.key" accordion="my-accordion" role="tabpanel">
                <div class="sow-accordion-panel-content">
                    <div>{{description.value}}</div>
                </div>
            </BCollapse>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Accordion",
        computed: {
            smeDescriptions: function() {
                return this.$store.state.SME_DESCRIPTIONS;
            }
        }
    }
</script>

<style scoped lang="stylus">
.sow-accordion
    margin-bottom 60px
    .sow-accordion-panel
        border-top 1px solid #ecebeb
        &:last-child
            border-bottom 1px solid #ecebeb
        .sow-accordion-panel-header
            cursor pointer
            .sow-accordion-title
                color #004666
                font-size 18px
                line-height 26px
                padding 26px 0
                display flex
                justify-content space-between
                font-family: "VWAGTheSansRegular", Arial, sans-serif;
                .sow-accordion-open-close-button
                    display inline-block
                    position relative
                    height 1px
                    .sow-accordion-button
                        display inline-block
                        position absolute
                        top 0
                        right -1px
                        color #004666
                        font-size 25px
                        &__arrow
                            display inline-block
                            background url("https://www.vwfsfleet.co.uk/app/themes/vwfs/img/icons/menu-arrow-down.svg") no-repeat #fff 50% 50%
                            width 40px
                            height 25px
                            z-index 10
                            content ''
                            &--close
                                transform: scaleY(-1);
            &.collapsed
                .sow-accordion-button--close
                    display none !important
                .sow-accordion-button--open
                    display inline-block !important

        .sow-accordion-panel-content
            margin-bottom 28px
</style>